import { render, staticRenderFns } from "./systemReportStatistics.vue?vue&type=template&id=4f5fa45b&scoped=true"
import script from "./systemReportStatistics.vue?vue&type=script&lang=js"
export * from "./systemReportStatistics.vue?vue&type=script&lang=js"
import style0 from "./systemReportStatistics.vue?vue&type=style&index=0&id=4f5fa45b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5fa45b",
  null
  
)

export default component.exports